module.exports = __webpack_public_path__ + "2600cd0bfa73ad01e0aed802be19ece2.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/3/Assets/img4.jpeg
// module id = 1330
// module chunks = 0